import { render } from "./App.vue?vue&type=template&id=731e6d95&scoped=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=731e6d95&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-731e6d95"

export default script